/* eslint-disable max-len */
function AttentionDynamicSvg(props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7264" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_38017_7264)">
            <path d="M4.125 4.125C1.43261 6.81739 1.43261 11.1826 4.125 13.875M13.875 13.875C16.5674 11.1826 16.5674 6.81739 13.875 4.125" stroke="#39404D" strokeWidth="1.04464" strokeLinecap="round" />
            <path d="M8.16792 12.4142L9.00017 11.5072C10.6924 11.5072 12.0643 10.1353 12.0643 8.44304C12.0643 6.75076 10.6924 5.37891 9.00017 5.37891C7.30789 5.37891 5.93604 6.75076 5.93604 8.44304C5.93604 8.86669 6.02202 9.27027 6.17748 9.63726" stroke="#39404D" strokeWidth="1.04464" strokeLinecap="round" />
        </g>
    </svg>;
}
export default AttentionDynamicSvg;
